import { render, staticRenderFns } from "./AgencyRoot.vue?vue&type=template&id=d5f404b2&scoped=true&"
import script from "./AgencyRoot.vue?vue&type=script&lang=js&"
export * from "./AgencyRoot.vue?vue&type=script&lang=js&"
import style0 from "./AgencyRoot.vue?vue&type=style&index=0&id=d5f404b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f404b2",
  null
  
)

export default component.exports